import styled, {css} from "styled-components"

import Icon from "@irati/ui/src/Icon"
import {ExpanderContent, ExpanderArrow} from "@irati/ui/src/Expander"
import {Input as InputTypeset} from "@irati/ui/src/Typography"

interface LabelProps {
  withEllipsis?: boolean
}

interface ContainerProps {
  inFocus: boolean
}

export const Container = styled.div<ContainerProps>`
  ${({inFocus, theme}) => css`
    flex: 1 0 0%;
    min-width: 0;
    max-width: 280px;
    border: 1px solid ${inFocus ? theme.colors.primary1 : theme.colors.utility.subdued};
    border-radius: ${theme.border.radius.small};
    background: ${theme.colors.utility.white};
    box-shadow: ${inFocus && theme.shadows.focus};

    ${theme.mediaQueries.minWidthMedia.tablet`
      flex: 1 0 100%;
    `}
  `}

  ${ExpanderContent} {
    position: relative;
  }

  ${ExpanderArrow} {
    flex: 0 0 auto;
  }
`

export const StyledIcon = styled(Icon)`
  flex: 0 0 auto;
  margin: ${({theme}) => theme.spacing.half};
`

export const Input = styled(InputTypeset)<LabelProps>`
  ${({withEllipsis}) =>
    withEllipsis &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`
